import { TELEGRAM_USER_LINK } from "features/admin/group/constants";
import { TelegramUser } from "@shared/types";

export const getTelegramUserLink = (telegramUser?: TelegramUser) => {
  if (telegramUser) return `${TELEGRAM_USER_LINK}${telegramUser?.username}`;
  return undefined;
};
